import { Text } from '../../components';
import { rem } from '../../utils/styles';
import styled from 'styled-components';
import { Button as MuiButton, Paper as MuiPaper } from '@mui/material';
import { ReportProblem } from '@mui/icons-material';

export const Wrapper = styled(MuiPaper)`
	display: flex;
	flex-direction: column;
	padding: ${rem(16)} ${rem(24)} ${rem(25)} ${rem(24)};
	width: 100%;
	border-radius: ${rem(12)};
	margin-bottom: ${rem(16)};
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${rem(8)};
	width: 100%;
`;

export const HeaderRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;

export const Header = styled(Text).attrs({
	as: 'h3',
	variant: 'text-medium',
})`
	margin: 0;
`;

export const ProductTitle = styled(Text).attrs({
	as: 'strong',
	variant: 'text-medium',
})`
	font-weight: 500 !important;
`;

/* one-line row with five columns */
export const Row = styled.div`
	display: flex;
	grid-template-columns: minmax(${rem(416)}, 2fr) auto 1fr 1fr 1fr;
	align-items: center;
	column-gap: ${rem(48)};
	row-gap: ${rem(8)};
	width: 100%;
	margin-top: ${rem(8)};
`;

/* left block: available text above the bar */
export const LeftBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${rem(8)};
	min-width: ${rem(416)};
	padding-right: ${rem(16)};
`;

export const Stats = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	column-gap: ${rem(16)};
	width: 60%;

	& > div {
		flex: 1 1 0;
		min-width: ${rem(200)};
	}
`;

export const BarInline = styled.div`
	display: flex;
	align-items: center;
	gap: ${rem(16)};
`;

export const ProgressWrapper = styled.div`
	width: 70%;
	max-width: ${rem(420)};
	min-width: ${rem(240)};

	height: ${rem(8)};
	background: #e0e0e0;
	border-radius: ${rem(4)};
	overflow: hidden;
`;

export const ProgressFill = styled.div<{
	percent: number;
}>`
	width: ${({ percent }) => `${percent}%`};
	height: 100%;
	background: ${({ percent }) => {
		if (percent <= 0) return '#BFBFBF'; // grey
		if (percent <= 15) return '#D74E26'; // red
		if (percent < 50) return '#EFB304'; // orange
		return '#2BC275'; // green
	}};
	transition: width 0.3s ease, background 0.3s ease;
`;

export const UnitInline = styled(Text).attrs({
	variant: 'text-medium',
})`
	margin: 0;
	white-space: nowrap;
`;

export const UsageText = styled.div<{ $isZero?: boolean }>`
	display: inline-flex;
	align-items: baseline;
	gap: 0.4rem;

	color: ${({ $isZero }) => ($isZero ? '#AA0000' : 'inherit')};
	strong {
		font-weight: 700;
	}
`;

export const Separator = styled.span`
	opacity: 0.8;
`;

export const CapIcon = styled(ReportProblem)`
	font-size: 1em;
	width: 1em;
	height: 1em;

	transform: translateY(0.14em);

	color: #aa5d00;
`;

export const UnitText = styled(Text).attrs({
	variant: 'text-medium',
})`
	margin: 0;
	white-space: nowrap;
`;

export const Stat = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${rem(2)};
	min-width: 0;
`;

export const StatLabel = styled(Text).attrs({
	variant: 'text-medium',
})`
	margin: 0;
	white-space: nowrap;
	line-height: 1.2;
`;

export const StatValue = styled(Text).attrs({
	variant: 'text-medium',
})`
	margin: 0;
	white-space: nowrap;
	color: #000000;
	font-size: ${rem(21)};
	line-height: 1.1;
`;

export const Button = styled(MuiButton)`
	text-transform: none;
	align-self: flex-end;
	padding: ${rem(6)} ${rem(12)};
	border: 1px solid #ccc;
	background: #fff;
	/* keep icon style consistent */
	.MuiButton-endIcon {
		margin-left: ${rem(6)};
	}
`;
